



























































































import {DoorIcon} from '@/icons';
import {RoomControlState} from '@/model/state/RoomControlState';
import {parseDecimalNumber} from '@/utils';
import {round} from 'lodash-es';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {RoomList} from './values';

type RawDimensions = [string, string, string];
type Dimensions = [number, number]|number;

@Component({components: {DoorIcon}})
export default class RoomControl extends Vue {
    @Prop({type: Object, required: true})
    public readonly roomLists: { [id: string]: RoomList };

    @Prop({type: Boolean, required: true})
    public readonly validate: boolean;

    @Prop({type: RoomControlState, required: true})
    public readonly state: RoomControlState;

    public dimensions: RawDimensions[] = [['', '', '']];

    public updatedDimensions(index: number, position: number, value: string): void {
        const dimensions: RawDimensions = Array.from(this.state.dimensions[index]) as RawDimensions;

        dimensions[position] = value;

        if (position === 2) {
            dimensions[0] = '';
            dimensions[1] = '';
        } else {
            dimensions[2] = '' + round(parseDecimalNumber(dimensions[0]) * parseDecimalNumber(dimensions[1]) || 0, 2);
        }

        this.state.updateDimensions(index, dimensions);
    }

    public addDimensions(): void {
        this.state.addDimensions(['', '', '']);
    }

    public removeRoom(): void {
        this.$emit('remove');
    }

    public removeDimensions(index: number): void {
        this.state.removeDimensions(index);
    }

    public areValid(index: number): boolean {
        return ! this.validate || this.state.areDimensionsValid(index);
    }

    protected updateRoomType(roomType: string): void {
        this.state.updateRoomType(roomType, this.roomLists.additional.includes(roomType));
    }

    protected isRoomNotSelected(): boolean {
        return this.validate && this.state.roomType === '';
    }
}
